// extracted by mini-css-extract-plugin
export default {"tooltip__line":"TooltipIconLabel_tooltip__line__xvPOP"};